import React from 'react';
import {FieldArray, useFormikContext} from 'formik';
import {Button, Icon, Input} from '../UI';
import { FormValues } from '../../common/interfaces';
import {MaskedInput} from '../UI/MaskedInput';

export const DriverLicenses = () => {
  const { values } = useFormikContext<FormValues>();

  return (
    <FieldArray name="licenses">
      {({ push, remove }) => (
        <div className="space-y-4">
          {values.licenses.map((_, index) => (
            <div key={index} className="flex items-end">
              <span className="w-10 text-slate-500 font-semibold">{index + 1}.</span>

              <div className="w-full grid grid-cols-4 gap-6">
                <Input name={`licenses.${index}.state`} label="State" />
                <Input name={`licenses.${index}.license`} label="License Number" />
                <Input name={`licenses.${index}.type`} label="Type" />
                <MaskedInput name={`licenses.${index}.expiration`} label="Expiration Date" mask='99/99/9999' />
              </div>

              {values.licenses.length > 1 && (
                <Button onClick={() => remove(index)}>
                  <Icon prefix='fal' icon='trash-alt' />
                </Button>
              )}
            </div>
          ))}

          <div className='flex justify-end'>
            <Button
              type='button'
              size='xs'
              onClick={() => push({ state: '', license: '', type: '', expiration: '' })}>
              + Add License
            </Button>
          </div>
        </div>
      )}
    </FieldArray>
  );
};